import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import HomePage from "@/pages/HomePage";
import ArticlePage from "@/pages/ArticlePage";
import AdminDashboard from "@/pages/AdminDashboard";
import UserDashboard from "@/pages/UserDashboard";
import PricingPage from "@/pages/PricingPage";
import SearchPage from "@/pages/SearchPage";
import IrishMarketsPage from "@/pages/IrishMarketsPage";
import IrishMartsPage from "@/pages/IrishMartsPage";
import MartsPage from "@/pages/MartsPage";
import UKMarketsPage from "@/pages/UKMarketsPage";
import USAMarketsPage from "@/pages/USAMarketsPage";
import NotFoundPage from "@/pages/NotFoundPage";
import MartEntryPage from "@/pages/MartEntryPage";
import CommunityPage from "@/pages/CommunityPage";
import TechnologyPage from "@/pages/TechnologyPage";
import MarketplacePage from "@/pages/MarketplacePage";
import CreateListingPage from "@/pages/CreateListingPage";
import ListingDetailPage from "@/pages/ListingDetailPage";
import MessagesPage from "@/pages/MessagesPage";
import AdvertisePage from "@/pages/AdvertisePage";
import ContentCalendarPage from "@/pages/ContentCalendarPage";
import AgriStocksPage from "@/pages/AgriStocksPage";
import StockNewsListPage from "@/pages/StockNewsListPage";
import StockNewsDetailPage from "@/pages/StockNewsDetailPage";
import ContactPage from "@/pages/ContactPage";
import StatusPage from "@/pages/StatusPage";
import FarmShopPage from "@/pages/FarmShopPage";
import AdminShopPage from "@/pages/AdminShopPage";
import IrishNewsPage from "@/pages/IrishNewsPage";
import UKNewsPage from "@/pages/UKNewsPage";
import USNewsPage from "@/pages/USNewsPage";
import GlobalNewsPage from "@/pages/GlobalNewsPage";
import AllNewsPage from "@/pages/AllNewsPage";
import LandListingsPage from "@/pages/LandListingsPage";
import LandDetailPage from "@/pages/LandDetailPage";
import FarmJobsPage from "@/pages/FarmJobsPage";
import FarmJobDetailPage from "@/pages/FarmJobDetailPage";
import TodaysMartPricesPage from "@/pages/TodaysMartPricesPage";
import DigestPreviewPage from "@/pages/DigestPreviewPage";
import UnsubscribePage from "@/pages/UnsubscribePage";
import GrantsPage from "@/pages/GrantsPage";
import PriceAlertsPage from "@/pages/PriceAlertsPage";
import AdminTakedownPage from "@/pages/AdminTakedownPage";
import AdminAnalyticsPage from "@/pages/AdminAnalyticsPage";
import PageTracker from "@/components/PageTracker";

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-[#FAF9F6]">
        <BrowserRouter>
          <PageTracker />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/article/:id" element={<ArticlePage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/dashboard" element={<UserDashboard />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/irish-markets" element={<IrishMarketsPage />} />
            <Route path="/todays-mart-prices" element={<TodaysMartPricesPage />} />
            <Route path="/digest" element={<DigestPreviewPage />} />
            <Route path="/unsubscribe" element={<UnsubscribePage />} />
            <Route path="/irish-marts" element={<IrishMartsPage />} />
            <Route path="/marts" element={<MartsPage />} />
            <Route path="/uk-markets" element={<UKMarketsPage />} />
            <Route path="/usa-markets" element={<USAMarketsPage />} />
            <Route path="/community" element={<CommunityPage />} />
            <Route path="/agri-tech" element={<TechnologyPage />} />
            <Route path="/technology" element={<TechnologyPage />} />
            <Route path="/marketplace" element={<MarketplacePage />} />
            <Route path="/marketplace/create" element={<CreateListingPage />} />
            <Route path="/marketplace/messages" element={<MessagesPage />} />
            <Route path="/marketplace/:id" element={<ListingDetailPage />} />
            <Route path="/advertise" element={<AdvertisePage />} />
            <Route path="/content-calendar" element={<ContentCalendarPage />} />
            <Route path="/agri-stocks" element={<AgriStocksPage />} />
            <Route path="/stock-news" element={<StockNewsListPage />} />
            <Route path="/stock-news/:id" element={<StockNewsDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/status" element={<StatusPage />} />
            <Route path="/shop" element={<FarmShopPage />} />
            <Route path="/admin/shop" element={<AdminShopPage />} />
            <Route path="/admin/mart-entry" element={<MartEntryPage />} />
            <Route path="/admin/takedown" element={<AdminTakedownPage />} />
            <Route path="/admin/analytics" element={<AdminAnalyticsPage />} />
            <Route path="/irish-news" element={<IrishNewsPage />} />
            <Route path="/uk-news" element={<UKNewsPage />} />
            <Route path="/us-news" element={<USNewsPage />} />
            <Route path="/global-news" element={<GlobalNewsPage />} />
            <Route path="/all-news" element={<AllNewsPage />} />
            <Route path="/land" element={<LandListingsPage />} />
            <Route path="/land-listings" element={<LandListingsPage />} />
            <Route path="/land-listings/:id" element={<LandDetailPage />} />
            <Route path="/jobs" element={<FarmJobsPage />} />
            <Route path="/grants" element={<GrantsPage />} />
            <Route path="/alerts" element={<PriceAlertsPage />} />
            <Route path="/farm-jobs" element={<FarmJobsPage />} />
            <Route path="/farm-jobs/:id" element={<FarmJobDetailPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </div>
    </AuthProvider>
  );
}

export default App;
